import type { ReactNode } from "react";
import { CaseSessionProvider } from "../../state/CaseSessionContext";

export function AppProviders({ children }: { children: ReactNode }) {
  return <CaseSessionProvider>{children}</CaseSessionProvider>;
}